import { __rest } from "tslib";
import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { Slot } from '@cmpkit/utils';
const Navigation = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({ ref: ref, className: clsx('navigation', className) }, props)));
});
Navigation.displayName = 'Navigation';
const NavigationContent = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({ ref: ref, className: clsx('navigation-content', className) }, props)));
});
NavigationContent.displayName = 'NavigationContent';
const NavigationSection = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({ ref: ref, className: clsx('navigation-section', className) }, props)));
});
NavigationSection.displayName = 'NavigationSection';
const NavigationIcon = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("span", Object.assign({ ref: ref, className: clsx('navigation-icon', className) }, props)));
});
NavigationIcon.displayName = 'NavigationIcon';
const NavigationText = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("span", Object.assign({ ref: ref, className: clsx('navigation-text', className) }, props)));
});
NavigationText.displayName = 'NavigationText';
const NavigationActivity = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("span", Object.assign({ ref: ref, className: clsx('navigation-activity', className, {
            'navigation-activity-dot': !props.children,
        }) }, props)));
});
NavigationActivity.displayName = 'NavigationActivity';
const NavigationChildren = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("span", Object.assign({ ref: ref, className: clsx('navigation-children', className) }, props)));
});
NavigationChildren.displayName = 'NavigationChildren';
const NavigationItem = forwardRef((_a, ref) => {
    var { className, active, as: Component = 'div', asChild } = _a, props = __rest(_a, ["className", "active", "as", "asChild"]);
    const Comp = asChild ? Slot : Component;
    return (React.createElement(Comp, Object.assign({ ref: ref, tabIndex: 0, className: clsx('navigation-item', className, { active }) }, props)));
});
NavigationItem.displayName = 'NavigationItem';
const NavigationItemContainer = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({ ref: ref, className: clsx('navigation-container', className) }, props)));
});
NavigationItemContainer.displayName = 'NavigationItemContainer';
const NavigationItemsGroup = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({ ref: ref, className: clsx('navigation-group', className) }, props)));
});
NavigationItemsGroup.displayName = 'NavigationItemsGroup';
export { Navigation, NavigationContent, NavigationSection, NavigationIcon, NavigationText, NavigationChildren, NavigationItem, NavigationItemContainer, NavigationItemsGroup, NavigationActivity, };
//# sourceMappingURL=index.js.map